(function () {
    'use strict';

    angular
        .module('directives.editInPlace', [])
        .directive('editInPlace', directive);

    directive.$inject = ['$document'];

    function directive($document) {
        return {
            restrict: 'AE',
            scope: {
                model: '=',
                type: '@',
                layoutRatio: '=?',
                placeholder: '@?',
                style: '=?',
                validation: '=?',
                disabledOn: '&?',
                whenChanged: '&?'
                //inputAttrs: '=?',
                // To Do: Dynamic input name 
                // http://stackoverflow.com/questions/23616578/issue-registering-form-control-with-interpolated-name#answer-23617401
            },
            transclude: true,
            replace: true,
            templateUrl: require('./editInPlace.tpl.html'),

            controller: ['$scope', function ($scope) {

                // Is Type Valid
                $scope.isTypeValid = function (type) {
                    return _.indexOf($scope.allowedTypes, type) > -1;
                };

                // Get Template Url
                $scope.getTemplateUrl = function () {

                    if (!$scope.isTypeValid($scope.type)) {
                        return;
                    }

                    return '/app/shared/components/directives/editInPlace-' + $scope.type + '.tpl.html';
                };

                // Confirm
                $scope.confirm = function ($event) {
                    $event.stopPropagation();

                    if ($scope.validation.ngRequired && !$scope.view.editModel) { return; }

                    $scope.view.isEditing = false;
                };

                // Cancel
                $scope.cancel = function ($event) {
                    $event.stopPropagation();

                    $scope.view.isEditing = false;

                    $scope.model = $scope.modelBeforeChanges;
                    $scope.view.editModel = $scope.model;
                };

                // On Change
                $scope.onChange = function () {
                    if ($scope.validation.ngRequired && !$scope.view.editModel) return;

                    $scope.model = $scope.view.editModel;
                    $scope.whenChanged();
                }

                // Get Layout Ratio
                $scope.getLayoutRatio = function () {
                    if (_.isUndefined($scope.layoutRatio)) {
                        return {
                            inputColumn: 'col-sm-10',
                            actionsColumn: 'col-sm-1',
                        };
                    }
                    return _.isString($scope.layoutRatio) ? $scope.$eval($scope.layoutRatio) : $scope.layoutRatio;
                }

                $scope.init = function () {

                    $scope.allowedTypes = ['text', 'textarea'];

                    if (!$scope.isTypeValid($scope.type)) {
                        throw 'Supported types for edit-in-place are: ' + $scope.allowedTypes.join(', ') + '\n';
                    }

                    $scope.view = {};
                }

            }],
            link: function (scope, element, attrs) {

                scope.init();

                // When clicked on edit-in-place
                var elemClickHandler = function (event) {
                    event.stopPropagation()

                    if (scope.view.isEditing) { return; }

                    if (!_.isUndefined(attrs.disabledOn) && scope.disabledOn()) {
                        return;
                    }

                    scope.modelBeforeChanges = scope.model;
                    scope.view.editModel = scope.model;
                    scope.view.isEditing = true;

                    scope.$apply();
                };
                element.on('click', elemClickHandler);

                // When enter pressed
                var elemEnterHandler = function (event) {
                    if (!scope.view.isEditing) { return; }

                    var code = event.keyCode || event.which;
                    if (code !== 13) { return; } // Not Enter

                    if (scope.type === 'textarea') { return; }

                    scope.confirm(event);
                    scope.$apply();
                };
                element.on("keypress", elemEnterHandler);

                // When clicked outside
                var documentClickHandler = function (event) {
                    if (!scope.view.isEditing) { return; }

                    scope.confirm(event);
                    scope.$apply();
                };
                $document.on('click', documentClickHandler);

                // Tear Down
                scope.$on('$destroy', function () {
                    element.off('click', elemClickHandler);
                    element.off('keypress', elemEnterHandler);
                    $document.off('click', documentClickHandler);
                });
            }
        };
    }
})();